import { Box } from "@mui/material";
import React from "react";
import WithLove from "../../common/components/WithLove";
import Topic from "../../common/components/Topic";
import Picture from "../../common/components/Picture";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
import Bullet from "../../common/components/Bullet";

// Images

import cover from "../../images/4.0/day2/0 Introduction.jpg";
import corruption from "../../images/4.0/day2/1. Corruption in the world.jpg";
import flesh from "../../images/4.0/day2/2. Flesh, the old Man.jpg";
import christ from "../../images/4.0/day2/3. Christ, the new man.jpg";
import delivers from "../../images/4.0/day2/4. Christ delivers the soul from corruption..png";
import workings from "../../images/4.0/day2/5. Workings of Christ_ Knowledge and Doctrine..jpg";
import principles from "../../images/4.0/day2/6.Principles.jpg";

export default function FourDayTwo() {
  return (
    <>
      <Box>
        <Topic>
          The Meat of the Word; God's provision to arrest corruption
        </Topic>
        <Text>
          1 Corinthians 3:1-3, 10:3-4, Ephesians 4:20-24, Colossians 3:10
        </Text>
        <br />
      </Box>
      <Picture src={cover} />
      <Section>
        <Section>
          <Title>Introduction </Title>

          <Content>
            {/* You are welcome to <b>Gadites Bible Seminar 4.0</b>.
            <br />
            <br /> */}
            In our previous study, we established that the origin of man’s
            problem was the corruptible seed, which entered the human race by
            the disobedience of Adam. Man journeyed in corruption towards this
            seed, which is able to eternally condemn the human race and God sent
            our Lord Jesus to stop this degeneration and much more, make man
            immune to corruption.
            <br />
            <br />
            Further, we learnt that the provision of God to achieve this plan of
            redemption is his word: the milk, the meat, and the strong meat. We
            saw how the milk provision of God’s word, though powerful, is
            limited in arresting the program of corruption in the soul.
            Nevertheless, this allocation of God’s word is able to prepare the
            believer for the meat, which according to scriptures, is able to
            arrest corruption.
            <br />
            <br />
            In today’s study, we will be exploring the meat allocation of God’s
            word by God’s grace. We trust the Lord for grace, skill, and
            utterance in Jesus name. Amen.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Corruption in the world</Title>
          <br />
          <Picture src={corruption} />
          <br />
          <Content>
            When man ate of the tree of the knowledge of good and evil, the
            corruptible seed entered into the human race. However, as earlier
            established, man didn't have the age, maturity, or wisdom required
            to unlock the corruptible seed, which we described as a process of
            corruption.
            <br />
            <br />
            This process of corruption is a course that Satan designed to
            develop men to be able to unlock the corruptible seed and
            consequently birth the corruptible nature. Satan embedded this
            course of corruption in a system called “this present world”{" "}
            <b>(2 Peter 1:4)</b>.
            <br />
            <br />
            The course of this world is a wisdom of life out of the corruptible
            seed but not the very wisdom of the seed{" "}
            <b>(Eph 2:1-2, 1 Cor. 2:6)</b>. The corruption in the world operates
            through lusts, which the scriptures define as the lust of the flesh,
            the lust of the eyes, and the pride of life <b>(1 John 2:15)</b>.
            Scriptures further classify these lusts as worldly lusts and
            ungodliness <b>(Tit 2:12)</b>.
            <br />
            <br />
            Over the years, mankind journeyed in corruption until these lusts
            fashioned and formed them accordingly, making them worldly and
            ungodly men, which the scriptures called carnal, flesh, or the old
            man, <b>(1 Pet 1:14, Rom 8:1-7, 12:2, Eph 4:22, Col 3:9)</b>.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Flesh, the old Man </Title>
          <br />
          <Picture src={flesh} />
          <br />
          <Content>
            Flesh, in the scriptures, does not speak only of the outward man or
            physical body, <b>(Gen 6:3, Joel 2:28)</b>. Rather, it describes a
            kind of man, which the corruption in the world fashioned. This man
            was formed by the law of sin and death, making him carnally minded,{" "}
            <b>(Rom 8:2, 6)</b>. This law is what the scriptures call the wisdom
            of this world, <b>(Mal 2:7)</b>.
            <br />
            <br />
            The flesh kind of man can exist in two states: worldly and ungodly,{" "}
            <b>(Tit 2:12)</b>. A worldly man is one whom the worldly lusts (lust
            of the flesh and lust of the eyes) have fashioned, while the ungodly
            man has gone beyond being worldly to be fashioned by the pride of
            life, <b>(1 John 2:16, Tit 2:12)</b>.
            <br />
            <br />
            The wisdom that forms the worldly man is earthly while the wisdom
            that forms the ungodly man is sensual, <b>(James 3:15)</b>. In
            Ephesians 4:22, Paul describes flesh as the old man who is corrupt
            according to deceitful lusts. It is good to know that a man can be
            born again, filled with the Holy Ghost, and even fed on the milk,
            yet, the wisdom of the world or corruption is still present in the
            soul, <b>(1 Cor. 3:1-3, Eph 4:22)</b>.
            <br />
            <br />
            It is good to reiterate that milk limits but does not deliver the
            soul from the world. Thus, a higher allocation of theword, which is
            the meat or the doctrine of Christ, is required to purify the soul
            from the wisdom of this world, <b>(2 Pet 1:4, 2 Pet 2:20)</b>.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Christ, the new man </Title>
          <br />
          <Picture src={christ} />
          <br />
          <Content>
            The word “Christ” is commonly used in the Christian circle, yet
            generally misunderstood. Most assume Christ to be the surname of our
            Lord Jesus. Rather, Christ is the man created after the image of God
            <b>(Col. 3: 10, Eph. 4:20-24)</b>. This new creature is commonly
            referred to in scriptures as the new man{" "}
            <b>(2 Cor. 5:17, Eph. 4:24, Col. 3:10)</b>.
            <br />
            <br />
            Christ, the new man, was created by God to deal with the corrupt
            formation that man inherited by obeying the course of this world,
            that is, the old man <b>(Col 3:9, Eph 4:22, Rom 6:6)</b>.
            <br />
            <br />
            According to 1 Cor. 10:3-4, Paul the Apostle described Christ as the
            spiritual meat and spiritual drink. Thus, we can conclude that the
            doctrine of Christ is the meat of God's word, which a believer, who
            has been weaned from the milk, should begin to partake of{" "}
            <b>(1 Cor. 3:2)</b>.
            <br />
            <br />
            In other words, the doctrine of Christ matures the believer,
            inducing spiritual growth from childhood to manhood{" "}
            <b>(1 Cor. 13:11)</b>. The meat of the word grows a man out of the
            child <b>(1 Cor. 3:2, Eph 4:20, 24; Heb. 6:1)</b>. This man is a
            spiritual man because he has become spiritually minded by obeying
            the law of the Spirit of life in Christ <b>(Romans 8:2, 6)</b>.
            <br />
            <br />
            The new man exists in two states: righteousness and true holiness,{" "}
            <b>(Eph 4:24)</b>. Righteousness describes the state of life that is
            in Christ, while true holiness is the stature of godliness, which is
            also a state of peace with God,{" "}
            <b>(Eph 4:24, Rom 8:6, 2 Pet 1:4)</b>.
            <br />
            <br />
            It is therefore good to know, that the escape from the corruption
            that is in the world through lust is a man called Christ, fashioned
            by the wisdom of life and godliness, <b>(2 Pet 1:4)</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Christ delivers the soul from corruption. </Title>
          <br />
          <Picture src={delivers} />
          <br />
          <br />
          <Content>
            Interestingly, just as corruption was initiated by the opening of
            the eyes, deliverance from corruption would also begin with the
            enlightenment of the believers understanding{" "}
            <b>(Acts 26:18, Eph 1:18)</b>.
            <br />
            <br />
            It is important to reiterate here that although the milk works out
            faith in the Lord Jesus and love unto all the saints, it cannot open
            the eyes of the believer. Thus, after hearing of the growth of the
            Ephesians by the milk, Paul began to pray that their eyes would be
            opened.
            <br />
            <br />
            The beginning of the deliverance from the corruption in the world is
            the opening of the eyes to see the hope of God’s calling for the
            saints. This operation is done by the giving of the spirit of wisdom
            and revelation in the knowledge of Christ <b>(Eph1:15-18)</b>.
            <br />
            <br />
            The doctrine of Christ is God's wisdom as against the corrupt wisdom
            of this world <b>(1 Cor 1:17-30)</b>. This wisdom was created by God
            to destroy the wisdom that fashioned flesh <b>(Gal 5:24)</b>. Thus,
            by learning Christ, the believer is empowered to put off the old man
            and put on the new man <b>(Eph 4:20-24)</b>.
            <br />
            <br />
            Furthermore, the soul of any believer who learns and obeys the
            doctrine of Christ is purified from this world <b>(1 Pet 1:22)</b>.
            Such a believer is free from the law of sin and death and has
            escaped the pollution that is in the world
            <b>(Rom 8:2, 2 Pet 2:20)</b>. This wisdom makes the believer
            righteous, sanctified, and redeemed <b>(1 Cor. 1:30)</b>.
            <br />
            <br />
            It is good to know that the dispensation of the wisdom and knowledge
            of Christ was given to Paul the Apostle to preach and teach the
            saints <b>(Eph 3:1-5)</b>.
          </Content>
        </Section>
        <Section>
          <Title>Workings of Christ: Knowledge and Doctrine.</Title>
          <br />
          <Picture src={workings} />
          <br />
          <br />
          <Content>
            We have seen that the milk prepares the believer for the meat
            allocation of the word or the doctrine of Christ. According to
            Isaiah 28:9-10, the milk qualifies one to participate in knowledge
            and doctrine. This knowledge and doctrine is the knowledge and
            doctrine of Christ. According to this scripture, knowledge are
            precepts while doctrine are lines.
            <br />
            <br />
            Precepts are well-aligned thoughts of scriptures through the
            activity of the spirit of wisdom and revelation{" "}
            <b>(Isaiah 11:2, Eph. 1:16)</b>. In simpler terms, precepts are the
            “What” of the knowledge of Christ. Meanwhile, lines are the ways of
            Christ through the activity ofthe spirit of counsel and might{" "}
            <b>(Isaiah 11:2, Eph 3:16)</b>. In simpler terms, lines are the
            “How” of the knowledge of Christ.
            <br />
            <br />
            We learn the precepts of Christ by sitting under anointed preachers
            and teachers of Christ <b>(Eph 4:11, 1 Tim 2:7, 2 Tim 1:11)</b>,
            while we learn the lines of Christ by the leading and dealings of
            the Spirit of truth <b>(Rom 8:14, John 16:13)</b>. According to
            Ephesians 4:20, we gain the precepts of Christ by hearing him while
            we acquire the lines of Christ by being taught by him. Also, our
            Lord Jesus explains this process in John 8:31-32. According to this
            scripture, continuing in his word is acquiring the knowledge or
            precepts of Christ while knowing the truth is acquiring the doctrine
            or lines of Christ.
            <br />
            <br />
            In summary, in our learning of Christ, we must not just have the
            knowledge or precepts, we must go on to acquire the doctrine or
            lines of Christ by obeying the leading and submitting to the
            dealings of the Spirit of Christ. This is the only way we can be
            cleansed from the corruption in the world and be free from the old
            man.
          </Content>
        </Section>
        <Section>
          <Title>Principles of Christ - Faith, Hope and Charity</Title>
          <br />
          <Picture src={principles} />
          <br />
          <br />

          <Content>
            According to Hebrews 6:1, it is clear that the doctrine of Christ
            has its principles. Paul provides a more explicit description of
            these principles as faith, hope, and charity{" "}
            <b>(1 Tim 1:14, 2 Tim 1:13, Gal 5:6, 1 Cor. 13:13)</b>, showing us
            that there are three levels in the doctrine of Christ; the beginning
            of the doctrine of Christ is faith while the end is charity{" "}
            <b>(1 Tim 1:5)</b>.
            <br />
            <br />
            Christ is described prophetically in Isaiah 28:16 as the stone, the
            tried stone, and the precious cornerstone, which speaks of the three
            stages of Christ's development: faith, hope, and charity,
            respectively.
            <br />{" "}
            <SubSection>
              <Subtitle>Faith</Subtitle>
              <Content>
                The faith of Christ justifies the believer by righteousness{" "}
                <b>(Gal 2:16, 20)</b>. The work of faith in the believer begins
                with the opening of the eyes of the believer's understanding to
                see the hope of the gospel{" "}
                <b>(Heb. 11:1, 2 Cor. 5:7, Eph. 1:18)</b>.
                <br />
                <br />
                This faith is different from the faith in the dispensation of
                the milk. It is the Faith that teaches a soul how to live for
                the hope of eternal life <b>(Tit 1:2)</b>. This Faith is not a
                faith for asking and receiving things from God{" "}
                <b>(Mark 11:23-24)</b> but rather it is a Faith for
                orchestrating and sustaining a righteous walk that pleases God
                in hope of eternal life <b>(Heb. 10:38, 11:6)</b>. The principle
                of faith transforms the believer from flesh (grass) into a
                stone.
              </Content>
              <br />
              <Subtitle>Hope</Subtitle>
              <Content>
                The season of Hope in the learning of Christ is a time when
                faith is made pure by fire, which are trials.{" "}
                <b>(1 John3:3, 1 Pet. 1:7, Rom 5:3-5)</b>. Hope worked in the
                heart of the believer purifies the heart and makes the believer
                rejoice in contradictions <b>(Rom 12:12)</b>. The time of hope
                is characterized by patience and experience. The quality of life
                acquired from this season produces a nature higher than that of
                faith. The principle of hope tries the stone, making the stone
                pure (tried stone) <b>(1 Pet 1:22)</b>.
              </Content>
              <br />

              <Subtitle>Charity</Subtitle>
              <Content>
                Every allocation of God's Word has its love expression. The love
                expression in the Milk of God's word is &#8220;Love unto all the
                saints&#8221;. The Meat of God;s Word, which is the teaching of
                Christ has a higher love expression, which is called Charity or
                the love of the brethren <b>(1 Pet. 1:22)</b>.
                <br />
                <br />
                Charity is not a mechanical display of actions but the formation
                of a nature in the soul. Charity is the greatest state in the
                formation of Christ. Such a believer has come into having peace
                with God. He is a contented man, a perfect man, a godly man{" "}
                <b>(1 Pet. 1:22)</b>. Before a man can walk in the love of the
                brethren (charity), he must have learnt to walk by faith and
                must have had his faith purified because Charity is the end of
                the commandment <b>(1 Tim. 1:5)</b>.
                <br />
                <br />
                Charity can be seen in two phases: Charity unto the brethren{" "}
                <b>(1 Cor. 13:4- 5)</b> and Charity unto God{" "}
                <b>(1 Cor. 13:6-7)</b>. The principle of charity makes the tried
                stone, precious. This is a perfect man, ready to interact with
                the incorruptible wisdom of God.
                <Bullet>
                  The Expression of Charity unto the brethren is
                  &#8220;unfeigned love of the brethren&#8221;. This is love
                  without dissimulation and strife <b>(Rom 12:9)</b>. Charity is
                  also to be learnt and practiced. The brethrenhere are a
                  community of believers who have the hope of Eternal Life as
                  their Hope and are journeying towards it. This expression of
                  Love teaches you to serve one another and regard others better
                  than yourself <b>(Phil 2:3)</b>. Charity towards your brethren
                  is devoid of worldly lust and self-gain
                  <b>(1 Cor 13:5, Gal 5:26)</b>. The Learning of Charity unto
                  the brethren is needed to train the soul for the &#8220;Love
                  of God&#8221;
                  <b>(1 John 4:20)</b>. This is because loving God is a higher
                  love expression than loving one another.
                </Bullet>
                <br />
                <Bullet>
                  The Expression of Charity towards God is simply expressed in
                  &#8220;Looking diligently/earnestly&#8221; for the blessed
                  Hope <b>(1 Cor. 2:9, Rom 8:28, Tit 2:13, Heb. 9:28, 12:15)</b>
                  . It is defined as the Love of the Father in 1 John 2:15. The
                  &#8220;Love of the Father&#8221; here is love for the things
                  of the Father. It is a love expression in the soul for the
                  incorruptible Life of the Father. This Charity expression
                  rejoices in the truth that is in the Father and seeks it
                  earnestly <b>(1 Cor. 13:6)</b>.
                </Bullet>
              </Content>
              <Content>
                In summary, the charity man is the spiritual man that can
                receive the things of the Spirit of God or the incorruptible
                seed, to be born of God{" "}
                <b>(1 Cor. 2:9-12, 1 Pet 1:22-23, 1 John 3:9)</b>.
                <br />
                <br />
                It is also good to mention that the charity man also faces the
                danger of being born of the corruptible seed because he has the
                age, maturity, or wisdom to unlock the genes of the devil
                <b>(Heb. 5:14)</b>. Hence, this is a season of great temptation
                for the journeying saint{" "}
                <b>(Matt. 6:13, James 1:13-14, Heb. 2:18)</b>.
              </Content>
            </SubSection>
          </Content>
        </Section>
      </Section>
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            In this study, we have been able to explore the meat of God's word,
            which is the doctrine of Christ. We have learnt that this allocation
            of God's word is able to arrest the program of corruption in the
            soul.
            <br />
            <br />
            However, we must reiterate that though the doctrine of Christ
            delivers the soul from corruption, it cannot make the soul
            incorruptible. Hence, the need for the strong meat of God's word,
            which can make the soul immune to corruption.
            <br />
            <br />
            We must understand that it is unsafe to remain in this allocation
            because such a believer is at risk of also being born of the
            corruptible seed as the age, wisdom, and maturity to do this has
            been attained by the doctrine of Christ. Thus, believers who have
            attained the full age of growth, should go on to be born of God by
            the incorruptible seed.
            <br />
            <br />
            In our next study, we would, by the grace of God, be exploring this
            allocation of God's word.
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
